import * as React from 'react';
import { IRolePerrmission } from '../RelationAccesses/AccessDomainModels';
import { Typography, Grid, Icon, Tooltip, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import lang from '../Relations/RelationsLang';

const useStyles = makeStyles((theme) => ({
	icon: {
		color: theme.palette.text.secondary,
		marginRight: theme.spacing(2),
	},
}));

interface IRolePermissionOptionProps {
	data: IRolePerrmission,
	administrativeRoleText: string,
	sensitiveDataText: string,
}

export function RolePermissionOption(props: IRolePermissionOptionProps) {
	const classes = useStyles();
	let option = props.data;
	return (
		<Grid container alignItems="center">
			<Grid item style={{ width: "35px" }}>
				{option.sensitiveData && <Icon className={classes.icon} title={props.sensitiveDataText} >warning</Icon>}
			</Grid>
			<Grid item xs>
				{option.name}
				<Typography variant="body2" color="textSecondary">
					{option.description}
					{option.administrativeRights && <> ({props.administrativeRoleText}) </>}
				</Typography>
			</Grid>
		</Grid>);
}

export function InfoLabel(props: {
	data: IRolePerrmission,
	administrativeRoleText: string,
	sensitiveDataText: string,
}) {

	if (props.data.description || props.data.administrativeRights) {
		return <Tooltip
			title={<>
				<Typography
					style={{ whiteSpace: "pre-line" }}
				>
					{props.data.description}
				</Typography>
				{props.data.administrativeRights && <p>({props.administrativeRoleText})</p>}
			</>}
		>
			<span>
				{props.data.name}
				{props.data.sensitiveData && <Icon
					style={{ verticalAlign: "middle", color: "#888" }}
					title={props.sensitiveDataText}
				>warning</Icon>}
				<Icon className="text-info" style={{ verticalAlign: "middle" }} >info</Icon>
			</span>
		</Tooltip>
	}

	return <span>
		{props.data.name}
		{props.data.sensitiveData && <Icon
			style={{ verticalAlign: "middle", color: "#888" }}
			title={props.sensitiveDataText}
		>warning</Icon>}
	</span>
}

export function getSensitiveDataPermissions(addedRoles: IRolePerrmission[], newRoles: IRolePerrmission[]) {

	let showWarningModal: IRolePerrmission[] = [];
	for (let i = 0; i < newRoles.length; i++) {
		let newRole = newRoles[i];
		if (newRole?.sensitiveData) {
			let notExist = addedRoles.filter(x => x?.id === newRole.id).length == 0;
			if (notExist)
				showWarningModal.push(newRole);
		}
	}
	return showWarningModal;
}

interface ISensitiveDataWarningDialogProps {
	showWarningModal: IRolePerrmission[];
	onAccept: () => void,
	onClose: () => void,
}

export function SensitiveDataWarningDialog(props: ISensitiveDataWarningDialogProps)
{
	function handleClose() {
		props.onClose();
	}

	function handleAccept() {
		props.onAccept();
	}

	return <Dialog
		className="sensitive-data-warning-dialog"
		open={props.showWarningModal.length != 0}
		onClose={handleClose}
		disableBackdropClick
	>
		<DialogTitle id="reason-for-processing-sensitive-data-dialog-title">{lang.reasonForProcessingSensitiveData()}</DialogTitle>
		<DialogContent>
			{props.showWarningModal.map(x => <DialogContentText
				key={x.id}
				style={{ whiteSpace: "pre-line" }}
			>
				{x.reasonForProcessingSensitiveData}
			</DialogContentText>)}
		</DialogContent>
		<DialogActions>
			<Button onClick={handleClose} color="default" variant="contained">
				{lang.get("cancel")}
			</Button>
			<Button onClick={handleAccept} color="primary" variant="contained" autoFocus>
				{lang.get("ok")}
          </Button>
		</DialogActions>
	</Dialog>;
}